import Vue from "vue";
import Vuex from "vuex";

import words from "@/data/words.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    words,
    index: 0,
  },
  mutations: {},
  actions: {},
  modules: {},
});
